import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import toast from 'react-hot-toast';
import axios from 'axios';

const ModalEditDescuento = ({ show, handleClose, descuento }) => {
	const token = localStorage.getItem('Token');
	const config = {
		headers: {
			xtoken: `${token}`,
		},
	};

	const [formData, setFormData] = React.useState({
		nombre: descuento?.nombre || '',
		descripcion: descuento?.descripcion || '',
		tipoDescuento: descuento?.tipoDescuento || 'porcentaje',
		porcentajeDescuento: descuento?.porcentajeDescuento || '',
		marca: descuento?.marca || '',
		tagAplicable: descuento?.tagAplicable || '',
		limiteUsos: descuento?.limiteUsos || '',
		estado: descuento?.estado ?? true,
	});

	React.useEffect(() => {
		setFormData({
			nombre: descuento?.nombre || '',
			descripcion: descuento?.descripcion || '',
			tipoDescuento: descuento?.tipoDescuento || 'porcentaje',
			porcentajeDescuento: descuento?.porcentajeDescuento || '',
			marca: descuento?.marca || '',
			tagAplicable: descuento?.tagAplicable || '',
			limiteUsos: descuento?.limiteUsos || '',
			estado: descuento?.estado ?? true,
		});
	}, [descuento]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		const parsedValue = name === 'estado' ? value === 'true' : value;

		setFormData((prev) => ({
			...prev,
			[name]: parsedValue,
		}));
	};

	const handleSaveData = async () => {
		try {
			await axios.put(
				`${process.env.REACT_APP_BACK_URL}/api/descuentos/${descuento?._id}`,
				formData,
				config
			);
			window.dispatchEvent(new Event('actualizar-descuentos'));
			toast.success('Descuento actualizado con éxito');
			handleClose();
		} catch (error) {
			console.error(error);
			toast.error('Error al actualizar el descuento');
		}
	};

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header className='headerModalHistorial' closeButton>
				<Modal.Title>Editar Descuento: {descuento?.nombre}</Modal.Title>
			</Modal.Header>
			<Modal.Body className='modalConfirmationContainer'>
				<div className='mb-2'>
					<label>Nombre (cupón):</label>
					<input
						className='form-control'
						type='text'
						name='nombre'
						value={formData.nombre}
						onChange={handleChange}
					/>
				</div>
				<div className='mb-2'>
					<label>Descripción:</label>
					<input
						className='form-control'
						type='text'
						name='descripcion'
						value={formData.descripcion}
						onChange={handleChange}
					/>
				</div>
				<div className='mb-2'>
					<label>Tipo de descuento:</label>
					<select
						className='form-control'
						name='tipoDescuento'
						value={formData.tipoDescuento}
						onChange={handleChange}
					>
						<option value='porcentaje'>Porcentaje</option>
						<option value='2x1'>2x1</option>
					</select>
				</div>
				{formData.tipoDescuento === 'porcentaje' && (
					<div className='mb-2'>
						<label>% Descuento:</label>
						<input
							className='form-control'
							type='number'
							name='porcentajeDescuento'
							value={formData.porcentajeDescuento}
							onChange={handleChange}
							min={1}
							max={100}
						/>
					</div>
				)}
				<div className='mb-2'>
					<label>Marca (opcional):</label>
					<input
						className='form-control'
						type='text'
						name='marca'
						value={formData.marca}
						onChange={handleChange}
					/>
				</div>
				<div className='mb-2'>
					<label>Tag aplicable (opcional):</label>
					<input
						className='form-control'
						type='text'
						name='tagAplicable'
						value={formData.tagAplicable}
						onChange={handleChange}
					/>
				</div>
				<div className='mb-2'>
					<label>Límite de usos (opcional):</label>
					<input
						className='form-control'
						type='number'
						name='limiteUsos'
						value={formData.limiteUsos}
						onChange={handleChange}
						min={1}
						placeholder='Ej: 50'
					/>
				</div>
				<div className='mb-2'>
					<label>Estado:</label>
					<select
						className='form-control'
						name='estado'
						value={formData.estado.toString()}
						onChange={handleChange}
					>
						<option value='true'>Activo</option>
						<option value='false'>Inactivo</option>
					</select>
				</div>

				<div className='divMagicoReset py-2 mt-4 d-flex justify-content-between'>
					<Button variant='secondary' onClick={handleClose}>
						Cerrar
					</Button>
					<Button className='botonModalConfirmacion' variant='primary' onClick={handleSaveData}>
						Guardar Cambios
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ModalEditDescuento;
